/*
 *
 * Global reducer
 *
 */

export const Types = {
  GET_UPDATE_REQUEST: 'global/GET_UPDATE_REQUEST',
  GET_UPDATE_SUCCESS: 'global/GET_UPDATE_SUCCESS',
  GET_UPDATE_FAILURE: 'global/GET_UPDATE_FAILURE',
};

export const initialState = {
  globalUpdateLoading: false,
  globalUpdateError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Atualiza um categoria
    case Types.GET_UPDATE_REQUEST:
      return {
        ...state,
        globalUpdateLoading: true,
        globalUpdateError: null,
      };
    case Types.GET_UPDATE_SUCCESS:
      return {
        ...state,
        globalUpdateLoading: false,
        globalUpdateError: null,
      };
    case Types.GET_UPDATE_FAILURE:
      return {
        ...state,
        globalUpdateLoading: false,
        globalUpdateError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  getGlobalUpdateRequest: ({
    name,
    cnpj,
    social_name,
    code_post,
    street,
    number,
    description,
    district,
    complement,
    city,
    logo_data,
    term_condition,
    privacy_policy,
  }) => ({
    type: Types.GET_UPDATE_REQUEST,
    payload: {
      name,
      cnpj,
      social_name,
      code_post,
      street,
      number,
      description,
      district,
      complement,
      city,
      logo_data,
      term_condition,
      privacy_policy,
    },
  }),
  getGlobalUpdateSuccess: () => ({
    type: Types.GET_UPDATE_SUCCESS,
  }),
  getGlobalUpdateFailure: error => ({
    type: Types.GET_UPDATE_FAILURE,
    payload: error,
  }),
};
